/**
 * GOBIND GHEE — THEME JS
 * Full AJAX cart, dynamic checkout, toast notifications
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     NAV SCROLL SHADOW
  ───────────────────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────
     MOBILE HAMBURGER MENU
  ───────────────────────────────────────── */
  const hamburgerBtn  = document.getElementById('hamburger-btn');
  const mobileNav     = document.getElementById('mobile-nav');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');
  const mobileClose   = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    mobileOverlay.classList.add('is-open');
    hamburgerBtn.classList.add('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileOverlay.classList.remove('is-open');
    hamburgerBtn.classList.remove('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburgerBtn) hamburgerBtn.addEventListener('click', openMobileNav);
  if (mobileClose)  mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ─────────────────────────────────────────
     FAQ ACCORDION
  ───────────────────────────────────────── */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item').forEach(el => {
        el.classList.remove('is-open');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ─────────────────────────────────────────
     SCROLL FADE-IN
  ───────────────────────────────────────── */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  /* ─────────────────────────────────────────
     CART COUNT — update all .cart-count spans
  ───────────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count, #cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  /* ─────────────────────────────────────────
     CART TOAST NOTIFICATION
  ───────────────────────────────────────── */
  function showCartToast(title, imageUrl) {
    let toast = document.getElementById('gg-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'gg-cart-toast';
      toast.style.cssText = [
        'position:fixed',
        'top:84px',
        'right:20px',
        'z-index:9999',
        'background:#1A1A1A',
        'color:#fff',
        'padding:14px 16px',
        'border-radius:12px',
        'font-size:14px',
        'font-weight:600',
        'box-shadow:0 12px 40px rgba(0,0,0,0.3)',
        'transform:translateX(calc(100% + 24px))',
        'transition:transform 0.35s cubic-bezier(0.34,1.56,0.64,1)',
        'display:flex',
        'align-items:center',
        'gap:12px',
        'max-width:320px',
        'min-width:260px',
        'border:1px solid rgba(255,255,255,0.08)'
      ].join(';');
      document.body.appendChild(toast);
    }

    const imgHtml = imageUrl
      ? '<img src="' + imageUrl + '" style="width:44px;height:44px;object-fit:cover;border-radius:8px;flex-shrink:0;" alt="">'
      : '<div style="width:44px;height:44px;background:rgba(212,160,23,0.2);border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0;">&#x1F9C8;</div>';

    toast.innerHTML = imgHtml +
      '<div style="flex:1;min-width:0;">' +
        '<div style="font-size:11px;opacity:0.6;font-weight:500;margin-bottom:3px;text-transform:uppercase;letter-spacing:0.06em;">Added to cart</div>' +
        '<div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + title + '</div>' +
      '</div>' +
      '<a href="/cart" style="background:#D4A017;color:#0F0F0F;font-size:12px;font-weight:700;padding:8px 14px;border-radius:8px;text-decoration:none;white-space:nowrap;flex-shrink:0;">View Cart</a>';

    requestAnimationFrame(() => {
      toast.style.transform = 'translateX(0)';
    });

    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => {
      toast.style.transform = 'translateX(calc(100% + 24px))';
    }, 5000);
  }

  /* ─────────────────────────────────────────
     AJAX ADD TO CART
     Intercepts ALL product forms with name="add"
  ───────────────────────────────────────── */
  function initAjaxCart() {
    document.querySelectorAll('form.product-card__form, form[action*="/cart/add"]').forEach(form => {
      if (form.dataset.ajaxInit) return;
      form.dataset.ajaxInit = 'true';

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const btn = form.querySelector('[name="add"]');
        if (!btn || btn.disabled) return;

        const origText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          const data = await res.json();

          if (!res.ok) {
            throw new Error(data.description || 'Could not add to cart');
          }

          // Success
          updateCartCount();
          const imgUrl = data.featured_image ? data.featured_image.url : null;
          showCartToast(data.product_title || data.title, imgUrl);

          btn.textContent = '&#10003; Added!';
          btn.style.background = '#22C55E';
          btn.style.borderColor = '#22C55E';
          setTimeout(() => {
            btn.textContent = origText;
            btn.style.background = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 2200);

        } catch (err) {
          console.warn('Cart error:', err.message);
          btn.textContent = 'Try Again';
          btn.style.background = '#EF4444';
          setTimeout(() => {
            btn.textContent = origText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        }
      });
    });
  }

  initAjaxCart();

  // Re-init for dynamically added forms (theme editor)
  document.addEventListener('shopify:section:load', () => {
    initAjaxCart();
    updateCartCount();
  });

  /* ─────────────────────────────────────────
     PRODUCT PAGE — VARIANT SELECTION
     Updates price + button state when variant changes
  ───────────────────────────────────────── */
  const variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      const price    = selected.dataset.price;
      const compare  = selected.dataset.compare;
      const avail    = selected.dataset.available === 'true';
      const priceEl  = document.getElementById('product-price');
      const compareEl = document.getElementById('product-compare-price');
      const addBtn   = document.querySelector('.product-add-btn');

      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) {
        if (compare && compare !== '0') {
          compareEl.textContent = compare;
          compareEl.style.display = 'inline';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
      }
      // Update hidden variant id in all forms on page
      document.querySelectorAll('input[name="id"]').forEach(inp => {
        inp.value = selected.value;
      });
    });
  }

  /* ─────────────────────────────────────────
     NEWSLETTER FORM FEEDBACK
  ───────────────────────────────────────── */
  const nlForm = document.getElementById('newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', () => {
      const btn = nlForm.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = '&#10003; Subscribed!';
        btn.style.background = '#22C55E';
      }
    });
  }

  /* ─────────────────────────────────────────
     SMOOTH ANCHOR SCROLL
  ───────────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
      }
    });
  });

  /* ─────────────────────────────────────────
     PRODUCT IMAGE GALLERY (product page)
  ───────────────────────────────────────── */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.querySelector('.product-main-img');
      if (mainImg) {
        mainImg.src = thumb.dataset.full || thumb.src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

})();
